import moment from 'moment';
import { API_DATE_FORMAT } from '../constants/dateFormats';
import {
  RECEIVE_DASHBOARD,
  UPDATE_DATE_RANGE,
  UPDATE_SELECTED_LOCALE,
  RECEIVE_CHART_DATA,
  RECEIVE_ERROR,
  DISMISS_ALERT,
  MESSAGING_FEATURES_MAP,
  SELECT_CAMPAIGN_ID,
  RECEIVE_EMAIL_CAMPAIGNS,
} from '~src/actions/messagingEmailDashboardAnalyticsActions';

const initialState = {
  startDate: moment()
    .subtract(30, 'days')
    .format(API_DATE_FORMAT),
  endDate: moment()
    .subtract(1, 'days')
    .format(API_DATE_FORMAT),
  supportedLocales: [],
  selectedLocale: {
    locale: 'en_US',
  },
  chartData: {},
  dimensions: [],
  errors: [],
  dashboard: {},
  object: '',
  reports: {},
  reportDefinitions: {},
  reportsPayload: [],
  alert: {
    show: false,
  },
  messagingFeatures: {},
  campaignId: null,
  campaigns: [],
};

export default (
  state = initialState,
  {
    type,
    meta,
    meta: { chartName } = {},
    payload: {
      startDate,
      endDate,
      selectedLocale,
      chartData,
      tableData,
      report_definitions: reportDefinitions,
      report_instances: reportInstances,
      dashboard_definitions: dashboard,
      messagingFeatures,
      campaignId,
      campaigns,
    } = {},
  } = {},
) => {
  let object;
  switch (type) {
    case RECEIVE_DASHBOARD:
      object = Object.keys(reportDefinitions)[0];
      return {
        ...state,
        dashboard,
        object,
        reports: {
          ...state.reports,
          ...reportInstances,
        },
        reportDefinitions,
      };
    case UPDATE_SELECTED_LOCALE:
      return {
        ...state,
        selectedLocale,
      };
    case UPDATE_DATE_RANGE:
      return {
        ...state,
        startDate,
        endDate,
      };
    case RECEIVE_CHART_DATA:
      return {
        ...state,
        chartData: {
          ...state.chartData,
          [chartName]: chartData,
        },
        tableData: {
          ...state.tableData,
          [chartName]: tableData,
        },
      };
    case RECEIVE_ERROR:
      return {
        ...state,
        alert: {
          color: 'danger',
          show: true,
          text:
            typeof meta.error !== 'string'
              ? 'Unknown error occured.'
              : `${meta.error}.`,
        },
      };
    case DISMISS_ALERT:
      return {
        ...state,
        alert: initialState.alert,
      };
    case MESSAGING_FEATURES_MAP:
      return {
        ...state,
        messagingFeatures,
      };
    case SELECT_CAMPAIGN_ID:
      return {
        ...state,
        campaignId,
      };
    case RECEIVE_EMAIL_CAMPAIGNS:
      return {
        ...state,
        campaigns,
      };
    default:
      return state;
  }
};
